import React from 'react';
import './About.css';

const About = () => (
  <div className="about">
    <h1>About Mongnis Prime</h1>
    <p>
      Mongnis Prime was born from a passion for baking and a love for celebrations. Every cake we create is more than a dessert — it’s a memory. From birthdays and weddings to everyday cravings, we bring joy through premium cakes crafted with care, creativity, and consistency.
    </p>
    <div className="stats">
      <div><strong>Years of Experience:</strong> 10+</div>
      <div><strong>Mission:</strong> To make every celebration sweeter</div>
      <div><strong>Vision:</strong> To become the most loved cake brand in the city</div>
    </div>
  </div>
);

export default About;
